if (!customElements.get('custom-carousel-slider')) {
  class CustomCarouselSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.carousel-track');
      this.slides = Array.from(this.track.children);
      this.dotsContainer = this.querySelector('.carousel-dots');
      this.prev = this.querySelector('.arrow.prev');
      this.next = this.querySelector('.arrow.next');
      this.current = 0;
      this.locked = false;

      this.autoplay = this.hasAttribute('autoplay');
      this.interval = parseInt(this.getAttribute('interval')) || 3000;
      this.timer = null;

      this.createDots();
      this.update();
      this.addEvents();
      console.log("autoplay :: ", this.autoplay);

      if (this.autoplay) this.startAutoplay();
    }

    startAutoplay() {
      console.log('Autoplay started');
      this.stopAutoplay();
      this.timer = setInterval(() => {
        if (!this.locked) {
          this.current = (this.current + 1) % this.slides.length;
          this.locked = true;
          this.update();
        }
      }, this.interval);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    update() {
      const total = this.slides.length;
      const prevIndex = (this.current - 1 + total) % total;
      const nextIndex = (this.current + 1) % total;

      this.slides.forEach((slide) => {
        slide.classList.remove('active', 'slide-prev', 'slide-next');
        const countEl = slide.querySelector('.carousel-count');
        if (countEl) countEl.textContent = '';
      });

      this.slides[prevIndex].classList.add('slide-prev');
      this.slides[this.current].classList.add('active');
      this.slides[nextIndex].classList.add('slide-next');

      const activeSlide = this.slides[this.current];
      const activeCount = activeSlide.querySelector('.carousel-count');
      if (activeCount) {
        activeCount.textContent = `${this.current + 1} | ${this.slides.length}`;
      }

      Array.from(this.dotsContainer.children).forEach((dot, i) => {
        dot.classList.toggle('active', i === this.current);
      });

      this.locked = false;
    }

    createDots() {
      this.dotsContainer.innerHTML = '';
      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.setAttribute('aria-label', `Slide ${i + 1}`);
        dot.addEventListener('click', () => {
          if (this.locked) return;
          this.current = i;
          this.update();
        });
        this.dotsContainer.appendChild(dot);
      });
    }

    addEvents() {
      // Arrows
      this.prev.addEventListener('click', () => {
        if (this.locked) return;
        this.current = (this.current - 1 + this.slides.length) % this.slides.length;
        this.locked = true;
        this.update();
        if (this.autoplay) this.startAutoplay();
      });

      this.next.addEventListener('click', () => {
        if (this.locked) return;
        this.current = (this.current + 1) % this.slides.length;
        this.locked = true;
        this.update();
        if (this.autoplay) this.startAutoplay();
      });

      // Disable dragging images & links
      this.slides.forEach(slide => {
        const img = slide.querySelector('img');
        if (img) {
          img.draggable = false;
          img.addEventListener('dragstart', e => e.preventDefault());
        }

        const link = slide.querySelector('a');
        if (link) {
          link.addEventListener('dragstart', e => e.preventDefault());
        }
      });

      // Swipe handling + prevent accidental link click
      let startX = 0;
      let dragging = false;
      let moved = false;

      const onPointerDown = (e) => {
        startX = e.clientX || e.touches?.[0]?.clientX;
        dragging = true;
        moved = false;

        const move = (e2) => {
          if (!dragging) return;
          const currentX = e2.clientX || e2.touches?.[0]?.clientX;
          const diff = currentX - startX;

          if (Math.abs(diff) > 10) {
            moved = true; // mark as drag
          }

          if (Math.abs(diff) > 50) {
            dragging = false;

            if (diff < 0) {
              this.current = (this.current + 1) % this.slides.length;
            } else {
              this.current = (this.current - 1 + this.slides.length) % this.slides.length;
            }

            this.update();
          }
        };

        const end = () => {
          dragging = false;
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', end);
          window.removeEventListener('touchmove', move);
          window.removeEventListener('touchend', end);
        };

        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', end);
        window.addEventListener('touchmove', move);
        window.addEventListener('touchend', end);
      };

      // Attach swipe only to images
      this.track.querySelectorAll('img').forEach(img => {
        img.addEventListener('pointerdown', onPointerDown);
        img.addEventListener('touchstart', onPointerDown, { passive: true });
      });

      // Block accidental redirect on drag
      this.track.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', (e) => {
          if (moved) {
            e.preventDefault();
          }
        });
      });
    }
  }

  customElements.define('custom-carousel-slider', CustomCarouselSlider);
}